module.exports = __webpack_public_path__ + "static/media/AMD-IBC.b9dfcc7f.jpg";